import { ModelBase } from '../../core/model/model-base';
import { Property } from './property';
import { RentalObject } from './rental-object';
import { ObjectComponentType } from './object-component-type';
import { ObjectComponentCategory } from './object-component-category';
import { Room } from './room';
import { ObjectComponentPropertyValue } from './object-component-property-value';
import { PlannedMaintenanceAction } from './object-component-planned-maintenance';
export class ObjectComponent extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.componentCategory = dataContext.componentCategory;
      this.componentType = dataContext.componentTypeId ? dataContext.componentTypeId : dataContext.componentType;
      this.id = dataContext.id;
      this.property = dataContext.property;
      this.rentalObject = dataContext.rentalObject;
      this.room = dataContext.room;
      this.installationMonth = dataContext.installationMonth ? dataContext.installationMonth : null;
      this.installationYear = dataContext.installationYear ? dataContext.installationYear : null;
      this.comment = dataContext.comment;
      this.name = dataContext.name;
      this.customPropertyValues = Array.isArray(dataContext.customPropertyValues)
        ? dataContext.customPropertyValues.map(x => {
            let i = new ObjectComponentPropertyValue(x);
            return i;
          })
        : [];
      this.plannedMaintenanceActions = Array.isArray(dataContext.plannedMaintenanceActions) ? dataContext.plannedMaintenanceActions : [];
      this.name = dataContext.name;
      this.attachments = Array.isArray(dataContext.attachments) ? dataContext.attachments : [];
    }
  }

  componentType: ObjectComponentType | string;

  get componentTypeId(): string {
    return this.componentType ? (typeof this.componentType !== 'string' ? this.componentType.id : this.componentType) : undefined;
  }

  set componentTypeId(id: string) {
    this.componentType = id;
  }

  componentCategory: ObjectComponentCategory | string;
  property: Property | string = null;
  rentalObject: RentalObject | string = null;
  room: Room | string = null;
  installationMonth: number = null;
  name: string = null;
  comment: string = null;
  installationYear: number = null;
  customPropertyValues: ObjectComponentPropertyValue[];
  plannedMaintenanceActions: PlannedMaintenanceAction[];
  attachments: any[];

  get ageInMonths(): number {
    if (!this.installationYear || !this.installationMonth) return undefined;

    let years = new Date().getFullYear() - this.installationYear;
    let months = new Date().getMonth() + 1 - this.installationMonth;
    if (months < 1) {
      months += 12;
      years -= 1;
    }
    if (years < 0) return undefined;
    return years * 12 + months;
  }

  toString(culture?: string): string {
    return this.name || this.comment || 'No name';
  }

  toJSON() {
    const json = Object.assign({}, this);
    json.componentType = this.componentTypeId;
    json.componentTypeId = this.componentTypeId;
    if (typeof this.componentCategory !== 'string' && this.componentCategory) {
      json.componentCategory = this.componentCategory.id;
    }
    if (this.property && typeof this.property !== 'string') {
      json.property = this.property.id;
    }
    if (this.rentalObject && typeof this.rentalObject !== 'string') {
      json.rentalObject = this.rentalObject.id;
    }
    if (this.room && typeof this.room !== 'string') {
      json.room = this.room.id;
    }

    return json;
  }
}
